import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {colorArray} from '../../../styles/shared/tagsColors';

class ColorsPicker extends Component {
  constructor(props) {
    super(props);
    this.startIndex = 0;
    this.endIndex = 5;
    const colors = this.generateColorsArray();
    this.state = {
      colors
    };
  }

  generateColorsArray = () => {
    const colors = colorArray.slice(this.startIndex, this.endIndex);
    this.startIndex =
      this.endIndex !== colorArray.length ? this.startIndex + 5 : 0;
    this.endIndex = this.endIndex !== colorArray.length ? this.endIndex + 5 : 5;

    return colors;
  };

  setColors = () => {
    const colors = this.generateColorsArray();
    this.setState({ colors });
  };

  render() {
    const { onClick, ...props } = this.props;
    const colorsPlate = this.state.colors.map((color, index) => (
      <button
        key={index}
        className="colorsPicker__roundButton colorsPicker__roundButton--small"
        onClick={() => onClick(color)}
        style={{ background: color }}
      />
    ));

    return (
      <div className="colorsPicker__container colorsPicker__container--small">
        {colorsPlate}
        <button
          className="colorsPicker__generateButton"
          onClick={this.setColors}
        >
          +
        </button>
      </div>
    );
  }
}

ColorsPicker.propTypes = {};
ColorsPicker.defaultProps = {};

export default ColorsPicker;
